import { Link } from 'react-router-dom';
import { genres } from '@/mocks/comics';

export default function SiteFooter() {
  return (
    <footer className="bg-primary-900 text-primary-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2" aria-label="动漫之家漫画网首页">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-book-open-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl text-background-50">动漫之家漫画网</span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-primary-200/90">
              聚合排行榜热门推荐、完结漫画与汉化组独家分类内容，一站逛完你想追的所有作品。
            </p>
            <div className="mt-4 flex items-center gap-3 text-primary-100">
              <a href="#" aria-label="哔哩哔哩" className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-800 transition-colors hover:bg-primary-700"><i className="ri-bilibili-fill"></i></a>
              <a href="#" aria-label="微博" className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-800 transition-colors hover:bg-primary-700"><i className="ri-weibo-fill"></i></a>
              <a href="#" aria-label="微信公众号" className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-800 transition-colors hover:bg-primary-700"><i className="ri-wechat-fill"></i></a>
              <a href="#" aria-label="抖音" className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-800 transition-colors hover:bg-primary-700"><i className="ri-douban-fill"></i></a>
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h3 className="font-heading text-base text-background-50">快速导航</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/ranking" className="text-primary-200/90 transition-colors hover:text-background-50">动漫之家排行榜</Link></li>
              <li><Link to="/completed" className="text-primary-200/90 transition-colors hover:text-background-50">完结漫画大全</Link></li>
              <li><Link to="/genre" className="text-primary-200/90 transition-colors hover:text-background-50">分类浏览</Link></li>
              <li><Link to="/about" className="text-primary-200/90 transition-colors hover:text-background-50">关于我们</Link></li>
              <li><Link to="/faq" className="text-primary-200/90 transition-colors hover:text-background-50">常见问题</Link></li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h3 className="font-heading text-base text-background-50">热门分类</h3>
            <ul className="mt-4 flex flex-wrap gap-x-4 gap-y-2.5 text-sm">
              {['热血', '恋爱', '玄幻', '悬疑', '搞笑', '日常', '科幻', '校园', '治愈', '冒险'].map((g) => (
                <li key={g}>
                  <Link to={`/genre?type=${encodeURIComponent(g)}`} className="text-primary-200/90 transition-colors hover:text-background-50">
                    {g}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-heading text-base text-background-50">联系我们</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-primary-200/90">
              <li className="flex items-center gap-2"><i className="ri-mail-line"></i><span>service@dmzj-comic.example.com</span></li>
              <li className="flex items-center gap-2"><i className="ri-qq-line"></i><span>官方交流群 9012 6677</span></li>
              <li className="flex items-center gap-2"><i className="ri-time-line"></i><span>在线更新 · 每周四加更</span></li>
            </ul>
            <div className="mt-4 rounded-lg bg-primary-800 px-4 py-3 text-sm">
              <p className="text-primary-100">想看排行榜、完结漫画还是汉化组独家？</p>
              <Link to="/ranking" className="mt-1 inline-block font-medium text-accent-400 hover:text-accent-300">去热门榜逛逛 →</Link>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-primary-800 pt-6 sm:flex-row">
          <p className="text-xs text-primary-300">© 2026 动漫之家漫画网 · 仅供漫画资讯展示，如侵请联系删除</p>
          <p className="text-xs text-primary-300">坚持原创内容 · 尊重每一位创作者</p>
        </div>
      </div>
    </footer>
  );
}